import { TOLGEE_GLOBALS } from 'utils'

export function getClusterTitle(t, type, topic, related) {
  if (type === 'CreatorClusterTopic' || type === 'CreatorClusterSubtopic') {
    return t({ ...TOLGEE_GLOBALS.CreatorClusterTopic, parameters: { topic, related, strong: <strong /> } })
  }
  return t({ ...TOLGEE_GLOBALS?.[type], parameters: { strong: <strong /> } })
}

export function getClusterTitleForTooltip(t, type, topic, related) {
  const tooltipKey = `${type}ForTooltip`
  if (type === 'CreatorClusterTopic' || type === 'CreatorClusterSubtopic') {
    return t({ ...TOLGEE_GLOBALS.CreatorClusterTopicForTooltip, parameters: { topic, related } })
  }
  return t(TOLGEE_GLOBALS?.[tooltipKey])
}
